import { css } from '@emotion/react';
import { breakpoints, flex, margins } from '@spotnana/blocks/src/utils';
import { paddings } from '@spotnana/blocks/src/utils/styling/utilityTokens';

export const segment_description = css`
  ${flex.init}
  ${paddings.yb.comfortable}
  ${flex.align.center}
`;

export const segment_title_container = css`
  ${flex.init}
  ${flex.align.center}
  ${margins.yb.half}
`;

export const min_width_container = css`
  min-width: 290px;
  ${breakpoints.from('large')} {
    min-width: 680px;
  }
`;

export const arrow_right_icon_container = css`
  ${paddings.x.superTight}
  min-width: 20px;
  ${flex.init}
  ${flex.align.center}
`;
